import { useMemo } from "react";
import { AxnCountry } from "@idw-types/data/reference-data/axn";
import { SelectFormGroup } from "../select-form-group/select-form-group";
import { BaseSelectFormGroupProps } from "./base-select-form-group-props";
import { resources } from "@constants/hardcoded-strings";

type CountrySelectFormGroupProps = BaseSelectFormGroupProps & {
    axnCountries: Array<AxnCountry>

};

export const CountrySelectFormGroup = (props: CountrySelectFormGroupProps) => {
    const { axnCountries, onChange, selectedOption, idPrefix, disabled, isRequired, isSearchable, isClearable, labelWidth } = props;

    const countryOptions = useMemo(() => {
        return axnCountries.map(country => ({ label: country.name, value: country.alpha2 }));
    }, [axnCountries]);

    return (
        <SelectFormGroup
            controlId={`${idPrefix}-country-select`}
            label={resources.common.inputs.country.label}
            ariaLabel={resources.common.inputs.country.label}
            automationId={`${idPrefix}-country-select`}
            onChange={onChange}
            options={countryOptions}
            selectedOption={selectedOption}
            disabled={disabled}
            isRequired={isRequired}
            isSearchable={isSearchable}
            isClearable={isClearable}
            labelWidth={labelWidth}
        />
    );
};